import React from 'react'
import { Switch, useRouteMatch } from 'react-router-dom'

import { EuiPage, EuiPageBody } from '@elastic/eui'

import PrivateRoute from '../../components/PrivateRoute'
import CampaignReportsPage from './campaign-reports/CampaignReportsPage'
import CampaignReportDetailPage from './campaign-reports/CampaignReportDetailPage'

const ReportsRouter: React.FC = () => {
  const { path } = useRouteMatch()
  
  return (
    <EuiPage className='euiPage--platform'>
      <EuiPageBody>
        <Switch>
          <PrivateRoute exact path={`${path}`}>
            <CampaignReportsPage />
          </PrivateRoute>
          <PrivateRoute path={`${path}/:campaignId`}>
            <CampaignReportDetailPage />
          </PrivateRoute>
        </Switch>
      </EuiPageBody>
    </EuiPage>
  )
}

export default ReportsRouter
